import { render, staticRenderFns } from "./cuidan.vue?vue&type=template&id=5cceef6c&scoped=true&"
import script from "./cuidan.vue?vue&type=script&lang=js&"
export * from "./cuidan.vue?vue&type=script&lang=js&"
import style0 from "./cuidan.vue?vue&type=style&index=0&id=5cceef6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cceef6c",
  null
  
)

export default component.exports